import axios from 'axios';
import * as actionTypes from './types';
import { addToast } from './index';

//add createStageMap here

export const createSlides = (logo, email, journeyId, primaryColor, secondaryColor, type) => async (
  dispatch
) => {
  dispatch(setSlidesLoading(true));
  try {
    await axios
      .post('/api/slides', {
        logo,
        email,
        journeyId,
        primaryColor,
        secondaryColor,
        type,
      })
      .then((res) => {
        dispatch(setSlidesLoading(false));

        if (res.data.errors) {
          dispatch(
            addToast({
              labels: { heading: 'Slide Generation Failed' },
              variant: 'error',
            })
          );
        } else {
          dispatch(
            addToast({
              labels: {
                heading: 'Slide Generation Successful',
              },
              variant: 'success',
            })
          );
        }

        if (res.data.webViewLink) {
          dispatch(addSlidesLink(res.data.webViewLink));
        }
      });

    dispatch(setSlidesLoading(false));
  } catch (err) {
    dispatch(setSlidesLoading(false));
    console.error(err);
  }
};

export const createStageMap = (logo, email, journeyId, type) => async (
  dispatch
) => {
  dispatch(setStageMapLoading(true));
  try {
    await axios
      .post('/api/slides', {
        logo,
        email,
        journeyId,
        type,
      })
      .then((res) => {
        dispatch(setStageMapLoading(false));

        if (res.data.errors) {
          dispatch(
            addToast({
              labels: {
                heading: 'StageMap Generation Failed',
              },
              variant: 'error',
            })
          );
        } else {
          dispatch(
            addToast({
              labels: {
                heading: 'StageMap Generation Successful',
              },
              variant: 'success',
            })
          );
        }
      });

    dispatch(setStageMapLoading(false));
  } catch (err) {
    dispatch(setStageMapLoading(false));
    console.error(err);
  }
};

export const setSlidesLoading = (isLoading) => ({
  type: actionTypes.SET_SLIDES_LOADING,
  isLoading,
});

export const setStageMapLoading = (isLoading) => ({
  type: actionTypes.SET_STAGEMAP_LOADING,
  isLoading,
});

//setStageMapLoading here

export const addSlidesLink = (slidesLink) => ({
  type: actionTypes.SET_SLIDES_LINK,
  slidesLink,
});
